<template>
    <router-link id="logo" :to="{name: 'LandingPage'}" class="r-center-flex">
        <div class="r-wd-40-max r-mr-8">
            <img :src="require('@/assets/logo.png')" alt="logo" class="r-isExpand">
        </div>
        <strong>YBPM Kudus</strong>
    </router-link>
</template>